<template>
  <div class="flow-block">
    <h4 class="flow-title">Identifique essa importação</h4>
    <p class="flow-subtitle">Esse nome aparece no histórico para você encontrar a carga depois.</p>
    <vs-input
      :value="value"
      class="w-full"
      placeholder="Ex: Esquenta Black Friday clientes fiéis"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'MassCustomerCategoriesStepIdentification',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
